"use client";

import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "@/hooks";
import { AppDispatch } from "@/store";
import { fetchAdminDashboard } from "@/store/modules/adminDashboard/thunks";
import { clearAdminDashboard } from "@/store/modules/adminDashboard/slice";
import { toast } from "react-toastify";

const useAdminDashboard = () => {
  const { params, setParams, handlePage } = useParams();
  const { per_page, current_page } = params;

  const { data, loading, error } = useSelector(
    (state: any) => state.adminDashboard,
  );
  const dispatch: AppDispatch = useDispatch();

  // Busca automática inicial (apenas uma vez)
  useEffect(() => {
    const payload = {
      ...params,
    };

    // Para desenvolvimento, você pode comentar esta linha e usar dados mock
    dispatch(fetchAdminDashboard(payload)).catch(() => {
      // Em caso de erro na API, usar dados mock para desenvolvimento
      console.log("Usando dados mock do dashboard administrativo");
    });
  }, []);

  const handleRefresh = async () => {
    const payload = {
      ...params,
    };

    try {
      await dispatch(fetchAdminDashboard(payload)).unwrap();
    } catch (err: any) {
      if (err?.error) {
        toast.error(err.error);
      } else {
        toast.error("Erro ao buscar dados do dashboard administrativo.");
      }

      dispatch(clearAdminDashboard());
    }
  };

  return {
    data,
    loading,
    error,
    handleRefresh,
    params,
    setParams,
    handlePage,
  };
};

export default useAdminDashboard;
